import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
   providedIn: 'root'
})
export class LayoutService {
   publicLogo$ = new BehaviorSubject<string | null>(null);
}
